module.exports = __webpack_public_path__ + "static/media/worker.a75c2391.svg";